'use strict';

/* global $ */


import { interfaceName } from './settings';

import { AjaxForm } from './modules/ajax-form';
import { Form } from './modules/ajax-form/form';
import { AjaxHandler } from './modules/ajax-handler';
import { Map } from './modules/map';
import { Regions } from './modules/regions';
import { Like } from './modules/like';
import { Slider } from './modules/slider';
import { Goal } from './modules/goal';
import { Responsive } from './modules/responsive';

class Proj {
	constructor() {
		this.init();
	}
	init() {
		this.interfaceName = interfaceName;
		console.log('[ interfaceName ]', this.interfaceName);

		this.ajaxForm = new AjaxForm();
		this.ajaxHandler = new AjaxHandler();
		this.goal = new Goal({
			goals: [
				{
					selector: '.js-goal__link',
					event: 'click',
					handler: function() {
						$(window).trigger('main:reachGoal', $(this).data());
					}
				}, {
					selector: '.js-goal__form',
					event: 'submit',
					handler: function() {
						$(window).trigger('main:reachGoal', $(this).data());
					}
				}, {
					selector: window,
					event: 'goal ajaxForm:goal',
					handler: function(e, data) {
						$(window).trigger('main:reachGoal', data);
					}
				}
			]
		});

		this.responsive = new Responsive();

		$('form').each(function() {
			this.form = new Form($(this), {skip_submit: 1});
		});

		$('[data-toggle="tooltip"], [data-tooltip="true"]').tooltip({
			trigger : 'hover'
		});
		$('[data-toggle="popover"]').popover({
			html: true,
			content: function() {
				let elementId = $(this).attr('data-popover-content');
				return $(elementId).html();
			}
		});

		let qrcode = document.getElementById('qrcode');
		if (qrcode) {
			console.log(qrcode.dataset.string);
			if (qrcode) {
				let string = qrcode.dataset.string;
				this.qrcode = new QRCode(qrcode, {
					text: string,
					width: 256,
					height: 256,
					colorDark : '#000000',
					colorLight : '#ffffff',
					correctLevel : QRCode.CorrectLevel.H
				});
			}
		}
		this.Map = new Map({
			selector: '.js-map'
		});
		this.Regions = new Regions({
			selector: '.js-regions'
		});
		this.Like = new Like({
			selector: '.js-likes'
		});
		this.Slider = new Slider({
            selector: '.js-slider',
            show: 1,
            scroll: 1,
            arrows: true,
            dots: true,
            fade: true,
            speed: 1000,
            //asnavfor: '.js-principles-background',
            rows: 1,
            perrorw: 1,
            //vertical: true,
            //verticalswiping: true,
            infinite: true,
            drag: true,
		});
		//console.log('BLA', document.cookie);
		$('#message').modal();
	}
}

$(function() {
	window.proj = new Proj();
});
